import { createSelector } from "@ngrx/store";
import { AppState } from "./core.state";

export const selectTimerState = (state: AppState) => state.timer;

export const selectTimer = createSelector(
  selectTimerState,
  (state) => state
);